import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { generatePath, useHistory } from 'react-router-dom'

import { AppRoute } from 'routing/AppRoute.enum'
import { Mutations } from 'api/mutations.enum'
import { Queries } from 'api/queries.enum'
import {
    DuplicatePulseSurveyPayload,
    DuplicatePulseSurveyResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { duplicatePulseSurvey } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

export const useDuplicatePulseSurvey = () => {
    const history = useHistory()

    const queryClient = useQueryClient()

    const { onChangeActivePulseSurvey } = usePulseSurveys()

    const mutation = useMutation<DuplicatePulseSurveyResponse, AxiosError, DuplicatePulseSurveyPayload>({
        mutationFn: duplicatePulseSurvey,
        mutationKey: [Mutations.duplicatePulseSurvey],
        onSuccess: async (pulseSurvey) => {
            const { uuid } = pulseSurvey

            await queryClient.invalidateQueries([Queries.getPulseSurveys])

            onChangeActivePulseSurvey(pulseSurvey)

            history.push(generateCompanyURI(generatePath(AppRoute.PulseSurveyCreate, { id: uuid })))
        },
    })

    return mutation
}
